import { Component, OnInit } from '@angular/core';
import { InformacionService } from "./services/informacion.service";
import { TranslateService } from 'ng2-translate';
import { ProductosService } from "./services/productos.service";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


const defaultLanguage = "es";
//Y como adicional el español
const additionalLanguages = ["en", "de", "fr"];
//Combinamos las traducciones disponibles al default.
const languages: string[] = [defaultLanguage].concat(additionalLanguages);


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  constructor ( public _is:InformacionService, public _ps:ProductosService, private translate: TranslateService ){}
  ngOnInit(){
    //Asignamos el lenguaje predefinido y los disponibles
          this.translate.setDefaultLang(defaultLanguage);
          this.translate.addLangs(additionalLanguages);
          //Nos basamos en el lenguaje del navegador para cambiar el lenguaje
          let initLang = this.translate.getBrowserLang();
          if (languages.indexOf(initLang) === -1) {
              initLang = defaultLanguage;
          }
  }
}



// WEBPACK FOOTER //
// /Users/administrador/Trabajos/pascal3/src/app/app.component.ts